// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__NzWJx","header":"ClearentDisclaimer_header__2fAJx","inner":"ClearentDisclaimer_inner__3Xm87"};